import api from "PFCore/api";
import { Id } from "PFTypes/id";
import { SkillsFramework, SkillsFrameworkCreateUpdateData } from "PFTypes/skills_framework";

export type UpdateSkillsFrameworkData = {
  id: Id;
  data: SkillsFrameworkCreateUpdateData;
};

export const updateSkillsFramework = ({ id, data }: UpdateSkillsFrameworkData) =>
  api<SkillsFramework>({
    url: `admin/skills_framework/templates/${id}`,
    method: "PUT",
    data
  });
